import { CloseCircleSolidIcon, InstagramIcon } from '@mm/icons';
import { ReactComponent as FBIcon } from 'assets/messenger-fb-new.svg';
import { ReactComponent as SMSIcon } from 'assets/smartphone.svg';
import { ReactComponent as WebchatIcon } from 'assets/webchat-new.svg';
import classNames from 'classnames';
import React, { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePhoneNumber } from '../../../../../../../common/hooks/use-phone-number';
import WidgetModel from '@mm/state/model/WidgetModel';
import { companyFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { colors } from '../../../../../beta/styles/colors';
import './WidgetPlatforms.pcss';

type Props = {
  className?: string;
  platforms: WidgetModel['supportedByPlatforms'];
};

const WidgetPlatform = ({
  title,
  disabled,
  icon,
}: {
  title: string;
  disabled: boolean;
  icon: ReactNode;
}) => {
  return (
    <div
      className={classNames('widget-platforms__platform', {
        'widget-platforms__platform--disabled': disabled,
      })}
    >
      <div className="widget-platforms__abbr">
        <div className="widget-platforms__title">{title}</div>

        {disabled && (
          <CloseCircleSolidIcon
            color={colors.red}
            className="widget-platforms__unsupported"
          />
        )}
        <div className="widget-platforms__icon">{icon}</div>
      </div>
    </div>
  );
};

export const WidgetPlatforms = ({ className, platforms }: Props) => {
  const { sms, instagram, facebook, webChat } = platforms;

  const { isSmsSupported } = usePhoneNumber();

  const iconId = useMemo(
    () => crypto.getRandomValues(new Uint8Array(16)).join(''),
    [],
  );

  return (
    <div className={classNames(className, 'widget-platforms')}>
      <WidgetPlatform title="Facebook" disabled={!facebook} icon={<FBIcon />} />
      <WidgetPlatform
        title="Web Chat"
        disabled={!webChat}
        icon={<WebchatIcon />}
      />
      <WidgetPlatform
        title="Instagram"
        disabled={!instagram}
        icon={<InstagramIcon id={iconId} />}
      />
      {isSmsSupported && (
        <WidgetPlatform
          title="SMS"
          disabled={!sms}
          icon={<SMSIcon height={17} />}
        />
      )}
    </div>
  );
};
